import React, { useContext } from "react";
import GlobalsContext from "../../context/GlobalsContext";

const ImageView = ({ name }) => {
  const globals = useContext(GlobalsContext);

  return name ? (
    <img src={`${globals.teaserImageHost}/400_400/${name}`} />
  ) : null;
};

export default ImageView;
